<!-- start header -->
<header>
    <!-- start navigation -->
    <nav class="navbar navbar-expand-lg navbar-light bg-transparent header-light fixed-top header-reverse-scroll">
        <div class="container-lg nav-header-container">
            <div class="col-auto col-sm-6 col-lg-2 me-auto ps-lg-0">
                <a class="navbar-brand" href="index.html">
                    <img src="assets/images/logo-gradient-magenta-orange.png" data-at2x="assets/images/logo-gradient-magenta-orange@2x.png" class="default-logo" alt="">
                    <img src="assets/images/logo-gradient-magenta-orange.png" data-at2x="assets/images/logo-gradient-magenta-orange@2x.png" class="alt-logo" alt="">
                    <img src="assets/images/logo-gradient-magenta-orange.png" data-at2x="assets/images/logo-gradient-magenta-orange@2x.png" class="mobile-logo" alt="">
                </a>
            </div>
            <div class="col-auto col-lg-8 menu-order px-lg-0">
                <button class="navbar-toggler float-end" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-label="Toggle navigation">
                    <span class="navbar-toggler-line"></span>
                    <span class="navbar-toggler-line"></span>
                    <span class="navbar-toggler-line"></span>
                    <span class="navbar-toggler-line"></span>
                </button>
                <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
                    <ul class="navbar-nav alt-font">
                        <li class="nav-item">
                            <a class="nav-link" href="home">Home</a>
                        </li>
                        <li class="nav-item">
                            <a [ngClass]="{'nav-link':true,active:isActive('products')}"  *ngIf="isLoggedIn$" [routerLink]="['products']">Supply Shop</a>
                        </li>
                        <li class="nav-item">
                            <a  [ngClass]="{'nav-link':true,active:isActive('bookings')}" [routerLink]="['bookings']" *ngIf="isLoggedIn$">Booking History</a>
                        </li>
                        <li class="nav-item">
                            <a  [ngClass]="{'nav-link':true,active:isActive('orders')}" [routerLink]="['orders']" *ngIf="isLoggedIn$">Billing</a>
                        </li>
                        <li class="nav-item">
                            <a  [ngClass]="{'nav-link':true,active:isActive('address_book')}" [routerLink]="['address_book']" *ngIf="isLoggedIn$">Address Book</a>
                        </li>
                        <li class="nav-item">
                            <a  [ngClass]="{'nav-link':true,active:isActive('about-us')}" [routerLink]="['about-us']">About Us</a>
                        </li>
                        <li class="nav-item">
                            <a  [ngClass]="{'nav-link':true,active:isActive('contact-us')}" [routerLink]="['contact-us']">Contact Us</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-auto text-end hidden-xs pe-0 font-size-0">
                <div class="header-cart-icon">
                    <a [routerLink]="['shopping-cart']" class="mx-2">
                        <i class="feather icon-feather-shopping-cart">
                            <span class="position-absolute top-0 start-20 translate-right badge rounded-pill bg-danger">{{cartService?.cart?.orderList?.length}}</span>
                        </i>
                    </a>
                </div>
                <div class="header-cart-icon" *ngIf="!isLoggedIn$">
                    <a [routerLink]="['/login']" ><i class="fa fa-user mx-1"></i>
                        <span class="text-small">Login/Register</span>
                    </a>
                </div>

                <!-- <div class="header-cart-icon" *ngIf="isLoggedIn$">
                    <a ><i class="fa fa-user mx-1"></i>
                        <span class="text-small">{{user$?.firstname}} {{user$?.lastname}}</span>
                    </a>
                </div> -->
                <div class="header-language dropdown d-lg-inline-block" *ngIf="isLoggedIn$">
                    <a href="javascript:void(0);">
                        <i class="feather icon-feather-user mx-1"></i>
                        <span class="text-medium">{{user$?.firstname}} {{user$?.lastname}} {{user$?.company_name}}</span>
                    </a>
                    <ul class="dropdown-menu alt-font">
                        <li [routerLink]="['profile']"><a href="javascript:void(0);" >Profile</a></li>
                        <li><a href="javascript:void(0);" (click)="authService.logout()" >Logout</a></li>
                    </ul>
                </div>



                
                <!-- <div class="header-language dropdown d-lg-inline-block">
                    <a href="javascript:void(0);"><i class="feather icon-feather-globe"></i>Language</a>
                    <ul class="dropdown-menu alt-font">
                        <li><a href="javascript:void(0);" title="English"><span class="icon-country"><img src="images/country-flag-16X16/usa.png" alt=""></span>English</a></li>
                        <li><a href="javascript:void(0);" title="England"><span class="icon-country"><img src="images/country-flag-16X16/england.png" alt=""></span>England</a></li>
                        <li><a href="javascript:void(0);" title="France"><span class="icon-country"><img src="images/country-flag-16X16/france.png" alt=""></span>France</a></li>
                        <li><a href="javascript:void(0);" title="Russian"><span class="icon-country"><img src="images/country-flag-16X16/russian.png" alt=""></span>Russian</a></li>
                        <li><a href="javascript:void(0);" title="Spain"><span class="icon-country"><img src="images/country-flag-16X16/spain.png" alt=""></span>Spain</a></li>
                    </ul>
                </div> -->
            </div>
        </div>
    </nav>
</header>
<!-- end header -->